import { Controller, FieldValues, Path, useFormContext } from 'react-hook-form';
import { DatePicker, DatePickerProps } from '@/shared/ui/core/datepicker';


type ControlledDatePickerProps<T extends FieldValues> = Omit<DatePickerProps, 'value' | 'onChange' | 'defaultValue'> & {
    name: Path<T>;
}

export const ControlledDatePicker = <T extends FieldValues>({ name, ...props }: ControlledDatePickerProps<T>) => {
    const { control, formState: { errors }, clearErrors } = useFormContext<T>();

    return (
        <Controller
            control={ control }
            name={ name }
            render={ ({ field }) => (
                <DatePicker
                    { ...props }
                    value={ field.value as Date | undefined }
                    onChange={ (date) => {
                        field.onChange(date);
                        clearErrors(name);
                    } }
                    error={ errors[name]?.message as string | undefined }
                />
            ) }
        />
    );
};
